import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import {
  ASSETS_ALL_ROLES,
  ROUTE_ASSETS_CHANGES_LOG_REPORT,
} from "../../SharedModule/utils/constants";
import { Spinner } from "../../SharedModule/components/Spinner";
import { setActiveTab } from "../../SharedModule/redux/reducers/uiShared.reducer";
import { verifyModuleAccess } from "../../SharedModule/utils/accessUtils";
import { ForbiddenPage } from "../../SharedModule/pages/ForbiddenPage";
import {
  selectAuth,
  selectUserRoles,
} from "../../SharedModule/redux/reducers/auth.reducer";
import { getHostUrl } from "../../ProductsModule/utils/reportsUtils";
import { TelerikReport } from "../../SharedModule/components/TelerikReport";

export const ChangesLogReportPage = () => {
  const auth = useSelector(selectAuth);
  const dispatch = useDispatch();

  // to help telerik reports to get correct local timezone
  const today = new Date();
  const importDate = new Date(
    Date.UTC(
      today.getFullYear(),
      today.getMonth(),
      today.getDate(),
      today.getHours(),
      today.getMinutes(),
      today.getSeconds()
    )
  );
  let parameters = {
    HostUrl: getHostUrl(),
    Auth: auth.accessToken,
    ActivityDate: importDate,
  };

  const { userRolesList, rolesLoaded } = useSelector(selectUserRoles);

  useEffect(() => {
    document.title = "The Hub - Asset Changes Log Report";
    dispatch(setActiveTab(ROUTE_ASSETS_CHANGES_LOG_REPORT));
  }, []);

  return (
    <>
      {!rolesLoaded && (
        <Spinner
          style={{
            marginLeft: "50%",
            marginTop: "5%",
          }}
        />
      )}
      {rolesLoaded &&
        !verifyModuleAccess(true, ASSETS_ALL_ROLES, userRolesList) && (
          <ForbiddenPage />
        )}

      {rolesLoaded &&
        verifyModuleAccess(true, ASSETS_ALL_ROLES, userRolesList) && (
          <TelerikReport
            title="Asset Change Log"
            reportName="AssetsHistory.trdp"
            parameters={parameters}
            parametersAreaVisible={false}
          />
        )}
    </>
  );
};
